"use client";
import { Image } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export default function HighlightTeaser(param) {
    var title = param.title, target = param.target, externalUrl = param.externalUrl, date = param.date, author = param.author, type = param.type, image = param.image, categories = param.categories, isEvent = param.isEvent;
    var _categories_getStarted, _categories_goDeeper, _categories_newsUpdates, _categories_foodForThought, _categories_eventType;
    var categoryClasses = "text-[7px] md:text-[9px] text-gray-100 font-heading mb-2 px-2 py-1 bg-gray-10 rounded-full uppercase inline-block";
    return /*#__PURE__*/ React.createElement("div", {
        className: "border border-gray-100 relative bg-white"
    }, /*#__PURE__*/ React.createElement("a", {
        href: externalUrl !== null && externalUrl !== void 0 ? externalUrl : target,
        className: "block group px-5 pt-5 pb-16 md:pb-9 lg:pb-8 focus"
    }, image && /*#__PURE__*/ React.createElement("div", {
        className: "mb-5 md:mb-7"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-w-12 aspect-h-5 relative block overflow-hidden"
    }, /*#__PURE__*/ React.createElement(Image, {
        source: image,
        className: "!absolute block w-full max-w-full object-cover h-full",
        alt: "".concat(title)
    }))), type ? /*#__PURE__*/ React.createElement("span", {
        className: "uppercase text-blue-500 text-xxs md:text-sm font-heading tracking-wider font-semibold block mb-2 md:mb-3"
    }, type) : null, /*#__PURE__*/ React.createElement("h3", {
        className: "text-xl md:text-3xl lg:leading-tight mb-4 md:mb-3 lg:mb-2 text-gray-600 font-heading md:pr-14 max-w-xl lg:max-w-full"
    }, title), /*#__PURE__*/ React.createElement("span", {
        className: clsx("text-sm md:pr-16 block", {
            "text-gray-200": !isEvent,
            "text-blue-500 font-medium": isEvent === true
        })
    }, date ? /*#__PURE__*/ React.createElement(React.Fragment, null, date) : null, date && author ? /*#__PURE__*/ React.createElement(React.Fragment, null, " | ") : null, author ? /*#__PURE__*/ React.createElement(React.Fragment, null, author) : null), categories ? /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-wrap gap-x-2 mt-2.5"
    }, (_categories_getStarted = categories.getStarted) === null || _categories_getStarted === void 0 ? void 0 : _categories_getStarted.map(function(item) {
        /*#__PURE__*/ return React.createElement("li", {
            key: item === null || item === void 0 ? void 0 : item.id,
            className: categoryClasses
        }, item === null || item === void 0 ? void 0 : item.name);
    }), (_categories_goDeeper = categories.goDeeper) === null || _categories_goDeeper === void 0 ? void 0 : _categories_goDeeper.map(function(item) {
        /*#__PURE__*/ return React.createElement("li", {
            key: item === null || item === void 0 ? void 0 : item.id,
            className: categoryClasses
        }, item === null || item === void 0 ? void 0 : item.name);
    }), (_categories_newsUpdates = categories.newsUpdates) === null || _categories_newsUpdates === void 0 ? void 0 : _categories_newsUpdates.map(function(item) {
        /*#__PURE__*/ return React.createElement("li", {
            key: item === null || item === void 0 ? void 0 : item.id,
            className: categoryClasses
        }, item === null || item === void 0 ? void 0 : item.name);
    }), (_categories_foodForThought = categories.foodForThought) === null || _categories_foodForThought === void 0 ? void 0 : _categories_foodForThought.map(function(item) {
        /*#__PURE__*/ return React.createElement("li", {
            key: item === null || item === void 0 ? void 0 : item.id,
            className: categoryClasses
        }, item === null || item === void 0 ? void 0 : item.name);
    }), (_categories_eventType = categories.eventType) === null || _categories_eventType === void 0 ? void 0 : _categories_eventType.map(function(eventType) {
        /*#__PURE__*/ return React.createElement("li", {
            key: eventType === null || eventType === void 0 ? void 0 : eventType.id,
            className: categoryClasses
        }, eventType === null || eventType === void 0 ? void 0 : eventType.name);
    })) : null, /*#__PURE__*/ React.createElement("div", {
        className: "absolute right-0 bottom-0 bg-yellow-500 group-hover:bg-orange-500 text-black group-hover:text-white transition p-3 md:p-5 lg:p-3.5"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "31px",
        height: "30px",
        viewBox: "0 0 31 30",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-638.000000, -6605.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Resources",
        transform: "translate(0.000000, 6046.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(0.000000, 130.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Resource-Tile/Featured",
        transform: "translate(73.000000, 14.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link/Arrow-Block",
        transform: "translate(550.000000, 400.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Arrow/Small",
        transform: "translate(15.000000, 15.000000)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "30",
        height: "30"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M18.1066017,4.39339828 L28.7132034,15 L18.1066017,25.6066017 M28.7132034,15 L1.71320344,15",
        id: "Icon",
        stroke: "currentColor",
        strokeWidth: "2.5"
    }))))))))))));
}
